import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Hero } from './components/Hero';
import { HeroTestimonials } from './components/HeroTestimonials';
import { ProblemSection } from './components/ProblemSection';
import { TomosSection } from './components/TomosSection';
import { BonosSection } from './components/BonosSection';
import { PricingSection } from './components/PricingSection';
import { ManualProSection } from './components/ManualProSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { CostOfInactionSection } from './components/CostOfInactionSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-night text-white font-sans selection:bg-gold-accent/30 selection:text-white" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Hero data-id="element-2" />
      <HeroTestimonials data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <TomosSection data-id="element-5" />
      <BonosSection data-id="element-6" />
      <PricingSection data-id="element-7" />
      <ManualProSection data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <CostOfInactionSection data-id="element-12" />
      <FinalCTASection data-id="element-13" />
      <Footer data-id="element-14" />
    </div>;
}